import React from 'react';

import { SearchResultLoading } from '../Item/SearchResultLoading.tsx';

import { SearchResultListLoadingContainer } from './styled.tsx';

export const SearchResultListLoading = (): React.JSX.Element => (
	<SearchResultListLoadingContainer>
		{[...Array(8)].map((_, idx) => (
			<SearchResultLoading key={idx} />
		))}
	</SearchResultListLoadingContainer>
);
